export default __webpack_public_path__ + "static/media/plus.2c7c01f1.svg";